import { render, staticRenderFns } from "./DemoChart.vue?vue&type=template&id=6d400b96&scoped=true"
import script from "./DemoChart.vue?vue&type=script&lang=js"
export * from "./DemoChart.vue?vue&type=script&lang=js"
import style0 from "./DemoChart.vue?vue&type=style&index=0&id=6d400b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d400b96",
  null
  
)

export default component.exports